export default class SettingNames {
  public static ProductImageXSmall = "ProductImageXSmall";
  public static ProductImageSmall = "ProductImageSmall";
  public static ProductImageMedium = "ProductImageMedium";
  public static ProductImageLarge = "ProductImageLarge";
  public static ProductImageXLarge = "ProductImageXLarge";
}
